import { render, staticRenderFns } from "./TheMainSubMenu.vue?vue&type=template&id=0ade57b9&scoped=true"
import script from "./TheMainSubMenu.vue?vue&type=script&lang=js"
export * from "./TheMainSubMenu.vue?vue&type=script&lang=js"
import style0 from "./TheMainSubMenu.vue?vue&type=style&index=0&id=0ade57b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ade57b9",
  null
  
)

export default component.exports